import { AdoptionComponent } from '../../constants/AdoptionComponent'

import { DS_ADOPTION_KEY, DS_COMPONENT_PARAMETER } from './constants'

export const hasEnabledAdoptionDsFlag = window?.localStorage?.getItem?.(DS_ADOPTION_KEY) === 'true'

export const getDsAdoptionAttribute = (componentName: AdoptionComponent | string) =>
  hasEnabledAdoptionDsFlag ? { [DS_COMPONENT_PARAMETER]: componentName } : {}
